// tslint:disable-next-line:max-line-length
import { Component, Input, OnInit, Output, EventEmitter, OnChanges, DoCheck, ChangeDetectionStrategy, SimpleChange} from '@angular/core';
import { ProductType } from '../../core/core.types';
import { Observable } from 'rxjs/Observable';
import { DatePipe } from '@angular/common';
import { NgForm, FormGroup, FormControl, Validators } from '@angular/forms';
import { Login } from '../../users/user.types';
import {INgxMyDpOptions, IMyDateModel, IMyDate} from 'ngx-mydatepicker';

@Component({
  selector: 'b4a-product-simple-travel-form-room-types',
  templateUrl: './simple-travel-form-room-types.component.html',
  styleUrls: ['./simple-travel-form-room-types.component.css'],
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimpleTravelFormRoomTypeComponent implements OnInit {

  changeLog: string[] = [];

  @Output() sendCopyToParent: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendIdForDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendValid: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendDisabledDatesArray: EventEmitter<any> = new EventEmitter<any>();

  @Input() index: number;

  @Input() roomType: any;

  @Input() roomTypes;

  @Input() minDateForOffer: Date;

  @Input() durValue;

  @Input() disableDaysArray;

  @Input() lenghtOfRooms;

  roomFormValid: boolean;

  roomFormValidArray: boolean[] = [];

  @Input() day;
  @Input() month;
  @Input() year;

  myOptions: INgxMyDpOptions = {
    // other options...
    dateFormat: 'dd.mm.yyyy',
  };

  private validDate = false;

  constructor () {
    this.roomType
  }

    getRoomValidator() {
      this.checkIfValid();
      return this.roomFormValid
    }

  ngOnInit(): void {
  this.myOptions.disableUntil = { year: this.year, month: this.month, day: this.day}
  this.myOptions.disableDates = this.disableDaysArray
  }

  check() {
    document.getElementById('aux-0-service').click();
  }

  test() {
    let len = this.lenghtOfRooms - 1;
    for (let i = 0; i <= len; i++) {
      let index = i.toString();
    document.getElementById('aux-' + index + '-service-new').click();
    }
  }

  copyRoom(basic, index) {
  this.sendCopyToParent.emit({basic, index});
  }

  checkIfValid() {
    this.roomFormValidArray = [];
      let len = this.lenghtOfRooms - 1;
      for (let i = 0; i <= len; i++) {
        let index = i.toString();
        document.getElementById('room-' + index).click();
      }
  }

  sendForm(roomForm: boolean) {
    if (!roomForm) {
      this.roomFormValid = false;
      this.sendValid.emit(false)
    }
  }

  setEndTermin(start) {
    if (start !== '') {
    let tempDate = new Date(start.jsdate);
    tempDate.setDate(tempDate.getDate() + this.durValue);
    this.roomType.end = tempDate;
    let tempStartDate = start.jsdate
    let dd = tempStartDate.getDate();
    let mm = tempStartDate.getMonth() + 1;
    let y = tempStartDate.getFullYear();

    if (this.roomType.start !== '') {
      if (this.roomType.newStart !== '' && this.roomType.newStart !== null) {
        let i = 0;
        for (let date of this.disableDaysArray){
          if (date.day === dd && date.month === mm && date.year === y) {
            this.disableDaysArray.splice( i, 1)
          // tslint:disable-next-line:max-line-length
          }else if (date.day === this.roomType.newStart.date.day && date.month === this.roomType.newStart.date.month && date.year === this.roomType.newStart.date.year){
            this.disableDaysArray.splice( i, 1)
          }
           i++
        }
            this.disableDaysArray.push({
              day: dd,
              month: mm,
              year: y
            })
        this.sendDisabledDatesArray.emit(this.disableDaysArray)
      }else{
        let i = 0;
        let oldStart = this.roomType.start.split('-')
        for (let date of this.disableDaysArray){
          if (date.day === Number(oldStart[2]) && date.month === Number(oldStart[1]) && date.year === Number(oldStart[0])) {
            this.disableDaysArray.splice( i, 1)
          }
          i++
        }
        this.disableDaysArray.push({
          day: dd,
          month: mm,
          year: y
        })
      this.sendDisabledDatesArray.emit(this.disableDaysArray)
      }
    }else {
      let oldStart = this.roomType.start.split('-')
      let i = 0;
      let avaibleDates = true;
      for (let date of this.disableDaysArray){
        if (date.day === Number(oldStart[2]) && date.month === Number(oldStart[1]) && date.year === Number(oldStart[0])) {
          this.disableDaysArray.splice( i, 1)
          avaibleDates = false;
        }
        i++
      }
      if (avaibleDates) {
      this.disableDaysArray.push({
        day: dd,
        month: mm,
        year: y
      })
    this.sendDisabledDatesArray.emit(this.disableDaysArray)
  }
    }
  this.roomType.start = y + '-' + mm + '-' + dd;
  }
}

  switchRoomType(roomType) {
    if (roomType === 'SGL') {
      this.roomType.roomType1 = 'DBL';
    }else {
      this.roomType.roomType1 = 'SGL';
    }
  }

  switchRoomType1(roomType1) {
    if (roomType1 === 'SGL') {
      this.roomType.roomType = 'DBL';
    }else {
      this.roomType.roomType = 'SGL';
    }
  }

  deleteRoom(roomType, index) {
    var r = confirm('Are you sure?');
    if (r === true) {
    console.log(roomType)
    if(roomType.newStart !== "" && roomType.newStart !== null){
      let i = 0;
          for (let date of this.disableDaysArray){
      // tslint:disable-next-line:max-line-length
      if (date.day === roomType.newStart.date.day && date.month === roomType.newStart.date.month && date.year === roomType.newStart.date.year) {
        this.disableDaysArray.splice(i, 1)
        this.sendDisabledDatesArray.emit(this.disableDaysArray)
         this.sendIdForDelete.emit({roomType, index});
    }
    i++
    }
  }else {
    this.sendIdForDelete.emit({roomType, index});
  }
}
  }

onCalendarToggle(event: number): void {}

displayCurrentValue(event, type){
  if(type == 'SGL'){
    this.roomType.price = Math.round(event * 100)
    if(isNaN(this.roomType.price)){
      this.roomType.price = 0
    }
  }else {
    this.roomType.price1 = Math.round(event * 100)
    if(isNaN(this.roomType.price1)){
      this.roomType.price1 = 0
    }
  }
}

SetValueOfPrice(price, type) {
  if (type === 'SGL') {
    if (price !== '') {
      let extractDecimal = price.slice(price.length - 3, price.length - 2)
      if (extractDecimal === ',') {
        let testPrice = price.slice(0, price.length - 3) + price.slice(price.length - 2, price.length)
        this.roomType.price = Number(testPrice)
      }else {
        this.roomType.price = Number(price * 100)
        this.roomType.priceForAdmin += ',00'
      }
    }
  }else {
    if (price !== '') {
      let extractDecimal = price.slice(price.length - 3, price.length - 2)
      if (extractDecimal === ',') {
      let testPrice1 = price.slice(0, price.length - 3) + price.slice(price.length - 2, price.length)
      this.roomType.price1 = Number(testPrice1)
    }else {
      this.roomType.price1 = Number(price * 100)
      this.roomType.price1ForAdmin += ',00'
    }
  }
  }
}

inputField(event, index) {
  let test = event.path[0].value
  let inputField = test
 let checkInput = Number(inputField);

if (isNaN(checkInput)) {
let datesArray = inputField.split('.')
let year = datesArray[2]
let month = datesArray[1]
let day = datesArray[0]
let dateObj = this.datesAlgorithm(year, month, day)

if (this.roomType.newStart !== '' && this.roomType.newStart !== null) {
  // logic on entering new date
  this.disableDatesNew(Number(dateObj.year), Number(dateObj.month), Number(dateObj.day), index)
}else {
  // logic on entering existing date
  this.disableDatesExisting(Number(dateObj.year), Number(dateObj.month), Number(dateObj.day), index)
}}else if (inputField.length === 8) {
    let year = inputField.slice(4, inputField.length)
    let day = inputField.slice(0, inputField.length - 6)
    let month = inputField.slice(2, inputField.length - 4)
    let dateObj = this.datesAlgorithm(year, month, day)
    if (this.roomType.newStart !== '' && this.roomType.newStart !== null) {
      // logic on entering new date
      this.disableDatesNew(Number(dateObj.year), Number(dateObj.month), Number(dateObj.day), index)
    }else {
      // logic on entering existing date
      this.disableDatesExisting(Number(dateObj.year), Number(dateObj.month), Number(dateObj.day), index)
    }
}else if (inputField.length < 4) {
  let dateNow = new Date();
  dateNow.setDate(dateNow.getDate() + Number(inputField))
  let day = dateNow.getDate();
  let month = dateNow.getMonth() + 1;
  let year = dateNow.getFullYear();
  console.log(dateNow)

  let dateObj = this.datesAlgorithm(year, month, day)
  if (this.roomType.newStart !== '' && this.roomType.newStart !== null) {
    // logic on entering new date
    this.disableDatesNew(Number(dateObj.year), Number(dateObj.month), Number(dateObj.day), index)
  }else {
    // logic on entering existing date
    this.disableDatesExisting(Number(dateObj.year), Number(dateObj.month), Number(dateObj.day), index)
  }
}
}

datesAlgorithm(year, month, day) {
  if (Number(month) > 12) {
    month = 12
    if (Number(day) > 31) {
      day = 31
    }
  }else {
    if (Number(day) > 31) {
    if (Number(month) === 1 ||
        Number(month) === 3 ||
        Number(month) === 5 ||
        Number(month) === 7 ||
        Number(month) === 8 ||
        Number(month) === 10 ||
        Number(month) === 12) {
          day = 31
 }
  if (Number(month) === 4 ||
      Number(month) === 6 ||
      Number(month) === 9 ||
      Number(month) === 11) {
        day = 30
  }

  if (Number(month) === 2) {
    if (Number(year) % 4 === 0  ) {
      day = 29
    }else {
      day = 28
    }
  }
}

if (Number(month) === 2) {
  if (Number(day) === 29) {
  if (Number(year) % 4 === 0  ) {
    day = 29
  }else {
    day = 28
  }
}
}
}

return {year, month, day}
}

disableDatesNew(year, month, day, index) {
  let i = 0;
  let avaibleDates = true;
  for (let date of this.disableDaysArray){
    if (date.day === day && date.month === month && date.year === year) {
      avaibleDates = false;
    }
  }
  if (avaibleDates) {
  this.disableDaysArray.push({
    day: Number(day),
    month:  Number(month),
    year: Number(year)
  })
  this.roomType.newStart = { date: { year: Number(year), month: Number(month), day: Number(day)}}
  this.roomType.start = year + '-' + month + '-' + day;
  document.getElementById('aux-' + index + '-service-new').click();
  this.sendDisabledDatesArray.emit(this.disableDaysArray)
  this.setEndDate(Number(year), Number(month), Number(day))
}
}


disableDatesExisting(year, month, day, index) {
  let oldStart = this.roomType.start.split('-')
  let i = 0;
  let avaibleDates = true;
  for (let date of this.disableDaysArray){
    if (date.day === day && date.month === month && date.year === year) {
      avaibleDates = false;
    }
  }
  if (avaibleDates) {
    for (let date of this.disableDaysArray){
      if (date.day === Number(oldStart[2]) && date.month === Number(oldStart[1]) && date.year === Number(oldStart[0])) {
        this.disableDaysArray.splice( i, 1)
      }
      i++
    }
  this.disableDaysArray.push({
    day: day,
    month: month,
    year: year
  })
  this.roomType.newStart = { date: { year: Number(year), month: Number(month), day: Number(day)}}
  this.roomType.start = year + '-' + month + '-' + day;
  document.getElementById('aux-' + index + '-service-new').click();
this.sendDisabledDatesArray.emit(this.disableDaysArray)
this.setEndDate(Number(year), Number(month), Number(day))
  }

}

setEndDate(year, month, day) {
  let tempDate = new Date(year, month - 1, day);
  tempDate.setDate(tempDate.getDate() + this.durValue);
  this.roomType.end = tempDate;
}
}



// WEBPACK FOOTER //
// ./src/app/product/simple-travel-form-room-types/simple-travel-form-room-types.component.ts